/**
 * Header component script
 * Handles header functionality including mobile menu
 */
import MobileMenu from './mobile-menu.js';
import SearchPanel from './search.js';

document.addEventListener('DOMContentLoaded', () => {
  new MobileMenu();
  new SearchPanel();
  
});
